import { render, staticRenderFns } from "./AddEditDialog.vue?vue&type=template&id=4a10f5b5&scoped=true&"
import script from "./AddEditDialog.vue?vue&type=script&lang=js&"
export * from "./AddEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddEditDialog.vue?vue&type=style&index=0&id=4a10f5b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a10f5b5",
  null
  
)

export default component.exports